import React from 'react';
import { Recipe } from '@/types/recipe';
import { MealPlan } from '@/types/mealPlan';
import { MealCompositionWithRecipes } from '@/types/mealComposition';
import { MealNote } from '@/types/mealNote';
import { format, subDays } from 'date-fns';
import { Skeleton } from '@/components/ui/skeleton';
import HomepageTile from './HomepageTile';

interface YesterdayMealsProps {
  mealPlans: MealPlan[];
  recipes: Recipe[];
  mealCompositions: MealCompositionWithRecipes[];
  mealNotes: MealNote[];
  isLoading: boolean;
}

const YesterdayMeals: React.FC<YesterdayMealsProps> = ({ 
  mealPlans, 
  recipes, 
  mealCompositions,
  mealNotes,
  isLoading 
}) => {
  const today = new Date();
  const yesterday = subDays(today, 1);
  const yesterdayFormatted = format(yesterday, 'yyyy-MM-dd');
  
  // Find meal plans for yesterday
  const yesterdayMealPlans = mealPlans.filter(mp => mp.date === yesterdayFormatted);
  
  // Find meal notes for yesterday
  const yesterdayNotes = mealNotes.filter(note => note.date === yesterdayFormatted);

  if (isLoading) {
    return (
      <div className="mb-6">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-charcoal font-playfair mb-4 mt-2">Yesterday's Meals</h2>
        <div className="space-y-2 p-3 border rounded-lg">
          <Skeleton className="h-3 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-6 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-charcoal font-playfair mb-4 mt-2">Yesterday's Meals</h2>
      <div className="[&>*]:!py-3 [&>*]:!min-h-0">
        <HomepageTile
          date={yesterday}
          mealPlans={yesterdayMealPlans}
          mealNotes={yesterdayNotes}
          recipes={recipes}
          mealCompositions={mealCompositions}
        />
      </div>
    </div>
  );
};

export default YesterdayMeals;